import { attr, hasMany } from '@ember-data/model';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
export default EmberDataBaseModel.extend({
  token: attr('string'),
  plans: hasMany('squareup/sub2/external-plan'),
  compareUrl: attr('string')
});